import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {staffApi} from "@/store/api/v1/staff";

export const scheduleApi = createApi({
    reducerPath: 'scheduleApi',
    tagTypes: ['schedule'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        createStaffSchedule: build.mutation({
            query: (data) => ({
                url: api.schedule.createStaffSchedule(),
                method: 'POST',
                body: data,
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data: updatedStaff } = await queryFulfilled;
                    // Update each staff member in the cache with new data
                    if (updatedStaff && Array.isArray(updatedStaff)) {
                        dispatch(
                            staffApi.util.updateQueryData('getStaff', {location_id: patch.location_id}, (draft) => {
                                updatedStaff.forEach((updatedStaffMember) => {
                                    const itemIndex = draft?.findIndex(item => item.id === updatedStaffMember.id);
                                    if (itemIndex !== -1) {
                                        draft[itemIndex] = updatedStaffMember;
                                    }
                                });
                            })
                        );
                    }
                } catch (error) {
                    console.error('Failed to update cache:', error);
                }
            },
        }),
    })
});

export const { useCreateStaffScheduleMutation } = scheduleApi;
